import React from "react";

const CalloutSection = () => (
  <section className="callout animatedParent animateOnce" data-appear-top-offset='-300'>
    <div className="container text-center animated fadeInDownShort">
      <h2 className="mx-auto mb-5 text-white padding-left ">
          Begrüße <br></br><em>deine</em><br></br> Gesundheit!
      </h2>
    </div>
  </section>
);
export default CalloutSection;



// WEBPACK FOOTER //
// ./src/main/callout.js